import { Box, Card, Skeleton, Stack } from '@mui/material';

export default function HelpArticleSkeleton() {
  return (
    <Box
      sx={{
        p: 3,
        my: 2,
        border: 1,

        borderColor: 'divider',
        width: '100%',
        borderRadius: 3,
        bgcolor: 'background.paper'
      }}
    >
      {/* Heading */}
      <Skeleton variant='text' width={220} height={48} />

      {/* Paragraph */}
      <Stack spacing={1} mt={2}>
        <Skeleton variant='text' width='100%' height={32} />
        <Skeleton variant='text' width='96%' height={32} />
        <Skeleton variant='text' width='98%' height={32} />
        <Skeleton variant='text' width='92%' height={32} />
        <Skeleton variant='text' width='75%' height={32} />
      </Stack>

      {/* Image */}
      <Card
        elevation={0}
        sx={{
          mt: 4,
          overflow: 'hidden',
          borderRadius: 3
        }}
      >
        <Skeleton
          variant='rounded'
          animation='wave'
          sx={{
            width: '100%',
            height: 280,
            borderRadius: 3
          }}
        />
      </Card>

      {/* Second Heading */}
      <Skeleton variant='text' width={250} height={44} sx={{ mt: 5 }} />
    </Box>
  );
}
